/**
 * @generated SignedSource<<a5bb3c3d8db54438b29dccd57ee85aac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTable_table$data = {
  readonly dataSource: string;
  readonly id: string;
  readonly sheets: ReadonlyArray<{
    readonly title: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTable_sheet">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "WidgetTable_table";
};
export type WidgetTable_table$key = {
  readonly " $data"?: WidgetTable_table$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTable_table">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTable_table",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataSource",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetTableSheet",
      "kind": "LinkedField",
      "name": "sheets",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTable_sheet"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTable",
  "abstractKey": null
};
})();

(node as any).hash = "ae9e37132f1c0c0349b3037857dc2978";

export default node;
